export const getClient = state => state.generics.client;

export default {
	getClient,
};
